import { Component, useState } from "react";
import "@/App.css";
import Intro from "@/components/Intro";
import LenisProvider from "@/components/LenisProvider";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Gallery from "@/components/Gallery";
import Coverage from "@/components/Coverage";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-slate-300 p-8 text-center">
          <p>Algo deu errado ao carregar a página. Recarregue para tentar novamente.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [ready, setReady] = useState(false);
  return (
    <ErrorBoundary>
      <LenisProvider>
        <div className="grain relative min-h-screen bg-ink text-slate-100 selection:bg-dm-glow/30">
          <Intro onComplete={() => setReady(true)} />
          <Navbar start={ready} />
          <main>
            <Hero start={ready} />
            <Marquee />
            <Services />
            <Gallery />
            <About />
            <Stats />
            <Coverage />
            <Contact />
          </main>
          <Footer />
          <Toaster position="bottom-right" richColors closeButton />
        </div>
      </LenisProvider>
    </ErrorBoundary>
  );
}

export default App;
